// @ts-strict-ignore
import type { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config'
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { AppRouteConfig } from '../../models'
import type { AuditObjectTypeConfigProvider } from '../../providers/interfaces'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import {
  AuditActionEnum,
  AuditObjectTypeEnum,
  AuditTypeEnum,
  FeatureIdEnum,
  FilterIdEnum,
  FilterTypeEnum,
} from '../../enums'
import { ArrayUtils, FeaturesTreeUtils } from '../../utils'
import Audit from '../../views/audit.view.vue'
import { ROUTER_CONSTS } from '../router.consts'

export function getObjectTypeFilterValues(
  instanceConfig: Instance,
  auditObjectTypeEnum: Array<string>,
): RegularFilterValueConfig[] {
  const featuresTree = FeaturesTreeUtils.getFeaturesTree(instanceConfig)

  const getAuditObjectTypeConfig = CONTAINER.get<AuditObjectTypeConfigProvider>(
    TYPES.AuditObjectTypeConfigProvider,
  )

  const alwaysVisibleTypes = new Set<string>([
    AuditObjectTypeEnum.CLIENT_CONFIG,
    AuditObjectTypeEnum.ENDPOINT_CONFIG,
    AuditObjectTypeEnum.FEATURE_CONFIG,
    AuditObjectTypeEnum.INDEX_CLIENT,
    AuditObjectTypeEnum.INDEX_FEED_CONFIGURATION,
    AuditObjectTypeEnum.INDEX_SCHEMA_CONFIGURATION,
  ])

  return [...auditObjectTypeEnum, AuditTypeEnum.CONFIG]
    .filter(objectType => {
      if (alwaysVisibleTypes.has(objectType)) return true

      const { featureId } = getAuditObjectTypeConfig(objectType)

      if (objectType === AuditObjectTypeEnum.BROWSE_CONFIGURATION) {
        return FeaturesTreeUtils.getFeatureNode(featureId, featuresTree[DomainEnum.BROWSE])
      }

      return Object.values(DomainEnum).some(domain =>
        FeaturesTreeUtils.getFeatureNode(featureId, featuresTree[domain]),
      )
    })
    .map(objectType => ({ id: objectType }))
    .sort(ArrayUtils.sortBy('id'))
}

export const AUDIT_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.AUDIT],
    path: 'audit',
    component: Audit,
    meta: {
      featureId: FeatureIdEnum.AUDIT,
      filters: (instanceConfig: Instance) => ({
        config: {
          [FilterIdEnum.DATE]: {
            enabled: true,
          },
        },
        extra: {
          [FilterIdEnum.AUDIT_OBJECT_TYPE]: {
            id: FilterIdEnum.AUDIT_OBJECT_TYPE,
            type: FilterTypeEnum.REGULAR,
            sortValuesDisabled: true,
            values: getObjectTypeFilterValues(instanceConfig, Object.values(AuditObjectTypeEnum)),
          },
          [FilterIdEnum.AUDIT_ACTION]: {
            id: FilterIdEnum.AUDIT_ACTION,
            type: FilterTypeEnum.REGULAR,
            sortValuesDisabled: true,
            values: Object.values(AuditActionEnum).map((action: AuditActionEnum) => ({
              id: action,
            })),
          },
        },
      }),
    },
  },
]
